import React from 'react';
import { Typography, Box } from '@mui/material';
import NetworkHealthCard from './NetworkHealthCard';
import { useTranslation } from 'react-i18next';

interface NetworkStrengthProps {
  status: string;
}

const NetworkStrength: React.FC<NetworkStrengthProps> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <NetworkHealthCard>
      <Typography variant="h6" gutterBottom>
        {t('network_strength')}
      </Typography>
      <Box
        sx={{
          fontSize: '1.5rem',
          fontWeight: 'bold',
          color:
            status === 'Excellent'
              ? '#4CAF50'
              : status === 'Fair'
              ? '#FFC107'
              : '#F44336',
        }}
      >
        {status}
      </Box>
    </NetworkHealthCard>
  );
};

export default NetworkStrength;
